import React, { Component } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Redirect } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Paper from "@material-ui/core/Paper";
import { generalS } from '../../../strings/general'

export default class SearchManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSuggestion: 0,
      posts: [],
      showSuggestions: false,
    }
  }

  componentDidMount() {
    const { posts } = this.props;
    this.setState({ posts })
  }

  handleSearch = () => {
    this.setState({ open: true })
  }

  clothHandler = () => {
    this.setState({ open: false })
  }

  onClick = (e) => {
    this.setState({
      activeSuggestion: 0,
      posts: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText
    });
  };

  onChange = (e) => {
    const { posts } = this.props;
    const userInput = e.currentTarget.value.toLowerCase();
    if (posts && posts.length > 0) {
      const newPosts = posts.filter(
        (post) => {
          if (post.title && post.title != "undefined")
            return post.title.toLowerCase().includes(userInput)
        }
      );

      this.setState({
        activeSuggestion: 0,
        posts: newPosts,
        showSuggestions: true,
        userInput,
      });
    }
  };

  suggestionsListComponent = () => {
    let { language } = this.props;
    let { showSuggestions, userInput, posts } = this.state;
    if (showSuggestions && userInput) {
      if (posts && posts.length) {
        return (
          <ul className="suggestions">
            {posts.map((post, index) => {
              return (
                <li key={post.postId} className={"suggestions-list"}>
                  <a
                    style={{ color: '#000' }}
                    href={`/detail?${post.postId}`}>{post.title}
                  </a>
                </li>
              );
            })}
          </ul>
        );
      } else {
        return (
          <div class="no-suggestions">
            <em>{generalS.postNotFound[language]}</em>
          </div>
        );
      }
    }
  }

  render() {
    let { open, userInput } = this.state;
    let { language } = this.props;
    return (
      <div>
        <SearchIcon
          onClick={this.handleSearch}
          className={"header-drawer"} />
        <Zoom in={open} style={{ transitionDelay: open ? '300ms' : '0ms' }}>
          <div className={"search-container"}>
            <div className={"search-close-container"}>
              <CloseIcon onClick={() => this.clothHandler(false)} />
            </div>
            <div className={"search-section"}>
              <div className={"search-input-container"}>
                <input
                  placeholder={generalS.search[language]}
                  type="text"
                  onChange={this.onChange}
                  value={userInput}
                />
                {this.suggestionsListComponent()}
              </div>
            </div>
          </div>
        </Zoom>
      </div>
    );
  }
}